module.exports = window.wp?.i18n;